import { PropertyDisplayFormat } from "../../Models/PropertyDisplayFormat";
import { formatRawDisplayValue } from "../../Utils/displayFormatting";

/**
 * Formats a value based on the specified format and options
 */
export default function formatValue(value: any, format: PropertyDisplayFormat | undefined, currencyCode?: string, phoneNumberFormat?: string): string {
  return formatRawDisplayValue(value, { format, currencyCode, phoneNumberFormat });
}
